/**
 * Product Page JS — Generalized from Sagrada Remastered
 * All selectors use pp- prefix (product page)
 * No external dependencies — vanilla JS
 */
(function() {
  'use strict';

  var root = document.querySelector('.pp-product');
  if (!root) return;

  // --- Auto-badge: convert (parenthesized text) to inline badges in richtext areas ---
  root.querySelectorAll('.pp-hero__credit, .pp-hero__description, .pp-deluxe__desc').forEach(function(el) {
    el.querySelectorAll('p, li').forEach(function(node) {
      if (node.innerHTML.indexOf('(') !== -1) {
        node.innerHTML = node.innerHTML.replace(/\(([^)]+)\)/g, '<span class="pp-inline-badge">$1</span>');
      }
    });
  });

  // --- Custom Variant Selector ---
  var variantSelect = root.querySelector('[data-pp-variant-select]');
  var priceDisplay = root.querySelector('[data-pp-variant-price]');
  var editionLabel = root.querySelector('[data-pp-variant-label]');
  var buyWrap = root.querySelector('[data-pp-buy-wrap]');
  var availabilityEl = root.querySelector('[data-pp-availability]');
  var heroAddBtn = root.querySelector('[data-pp-hero-add]');

  // Floating cart elements
  var floatCart = root.querySelector('[data-float-cart]');
  var floatPrice = root.querySelector('[data-float-price]');
  var floatVariant = root.querySelector('[data-float-variant]');
  // In multi-edition mode each button owns a fixed variant, so the hero's
  // selection must not rewrite them — only the single-button bar follows it.
  var floatMulti = !!root.querySelector('.pp-float-cart__options');
  var floatAddBtn = floatMulti ? null : root.querySelector('[data-float-add]');

  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      var variantId = selectedOption.value;
      var price = selectedOption.getAttribute('data-price');
      var variantTitle = selectedOption.textContent.trim();

      if (editionLabel) editionLabel.textContent = variantTitle;
      if (priceDisplay && price) priceDisplay.textContent = price;

      // Toggle buy form vs availability message based on variant stock
      var isAvailable = selectedOption.getAttribute('data-available') === 'true';
      var availDate = selectedOption.getAttribute('data-availability-date');
      if (buyWrap && availabilityEl) {
        if (isAvailable) {
          buyWrap.style.display = '';
          availabilityEl.style.display = 'none';
        } else {
          buyWrap.style.display = 'none';
          availabilityEl.style.display = '';
          var soldOutLabel = availabilityEl.getAttribute('data-unavailable-label') || 'Sold Out';
          availabilityEl.textContent = availDate ? 'Available ' + availDate : soldOutLabel;
        }
      }

      // Sync hero add-to-cart button variant
      if (heroAddBtn) heroAddBtn.setAttribute('data-variant-id', variantId);

      // Sync floating cart
      if (floatPrice && price) floatPrice.textContent = price;
      if (floatVariant) floatVariant.textContent = variantTitle;
      if (floatAddBtn) floatAddBtn.setAttribute('data-variant-id', variantId);
    });
  }

  // --- Floating Cart: Show on scroll, Add to cart ---
  if (floatCart) {
    var heroSection = root.querySelector('.pp-hero');
    var showThreshold = heroSection ? heroSection.offsetHeight : 500;

    function checkFloatCartVisibility() {
      if (window.scrollY > showThreshold) {
        floatCart.classList.add('visible');
      } else {
        floatCart.classList.remove('visible');
      }
      var atBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 100);
      if (atBottom && window.innerWidth >= 768) {
        floatCart.classList.add('at-footer');
      } else {
        floatCart.classList.remove('at-footer');
      }
    }

    window.addEventListener('scroll', checkFloatCartVisibility, { passive: true });
    checkFloatCartVisibility();

    // The bar can carry one button per edition, so bind them all — each acts on
    // its own variant rather than on whatever the hero has selected.
    root.querySelectorAll('[data-float-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        addToCart(btn.getAttribute('data-variant-id'), btn);
      });
    });
  }

  // --- Info Panel Accordion ---
  root.querySelectorAll('[data-panel-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var panel = btn.closest('[data-info-panel]');
      if (panel) panel.classList.toggle('open');
    });
  });

  // --- Utility: parse YouTube URL to embed URL ---
  function youtubeEmbed(url) {
    if (!url) return null;
    var match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?#]+)/);
    if (match) return 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&rel=0';
    return null;
  }

  // --- Shared Add to Cart + Cart Badge Update ---
  function updateCartBadge() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var countEl = document.querySelector('[data-cart-count]');
      var bubble = document.querySelector('[data-cart-count-bubble]');
      if (countEl) countEl.textContent = cart.item_count;
      if (bubble) {
        if (cart.item_count > 0) bubble.classList.remove('hide');
        else bubble.classList.add('hide');
      }
    });
  }

  // --- Upsell Drawer ---
  var upsellDrawer = document.getElementById('pp-upsell-drawer');
  var upsellBackdrop = document.getElementById('pp-upsell-backdrop');
  var upsellClose = document.getElementById('pp-upsell-close');

  function openUpsellDrawer() {
    if (!upsellDrawer) return;
    upsellDrawer.classList.add('open');
    if (upsellBackdrop) upsellBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeUpsellDrawer() {
    if (!upsellDrawer) return;
    upsellDrawer.classList.remove('open');
    if (upsellBackdrop) upsellBackdrop.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (upsellClose) upsellClose.addEventListener('click', closeUpsellDrawer);
  if (upsellBackdrop) upsellBackdrop.addEventListener('click', closeUpsellDrawer);

  // Upsell item add-to-cart buttons
  if (upsellDrawer) {
    upsellDrawer.querySelectorAll('[data-upsell-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        addToCart(btn.getAttribute('data-variant-id'), btn, true);
      });
    });
    // Upgrade buttons — add bundle, remove replaced products from cart
    upsellDrawer.querySelectorAll('[data-upsell-upgrade]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var bundleVariantId = btn.getAttribute('data-variant-id');
        var replacesRaw = btn.getAttribute('data-replaces-handles') || '';
        var currentHandle = btn.getAttribute('data-current-handle');
        var handles = replacesRaw ? replacesRaw.split(',').map(function(h) { return h.trim(); }).filter(Boolean) : [];
        if (!handles.length && currentHandle) handles = [currentHandle];
        upgradeToBundle(bundleVariantId, handles, btn);
      });
    });
  }

  function upgradeToBundle(bundleVariantId, replaceHandles, btn) {
    if (!bundleVariantId) return;
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Upgrading...';
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var updates = {};
        replaceHandles.forEach(function(handle) {
          var item = cart.items.find(function(i) { return i.handle === handle; });
          if (item) updates[item.variant_id] = Math.max(0, item.quantity - 1);
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(bundleVariantId), quantity: 1 }] })
        });
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function() {
        btn.textContent = 'Redirecting...';
        window.location.href = '/checkout';
      })
      .catch(function() {
        btn.textContent = 'Error';
        setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
      });
  }

  function addToCart(variantId, btn, skipUpsell) {
    if (!variantId) return;
    var origText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    }).then(function() {
      btn.textContent = 'Added!';
      updateCartBadge();
      setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
      if (!skipUpsell && upsellDrawer) openUpsellDrawer();
      else if (skipUpsell && window.openMiniCart) window.openMiniCart();
    }).catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
    });
  }

  // --- Hero Add to Cart (custom button, no framework dependency) ---
  if (heroAddBtn) {
    heroAddBtn.addEventListener('click', function() {
      var variantId = variantSelect ? variantSelect.value : heroAddBtn.getAttribute('data-variant-id');
      addToCart(variantId, heroAddBtn);
    });
  }

  // --- Gallery ---
  var galleryMain = root.querySelector('[data-gallery-main]');
  if (galleryMain) {
    var mainImg = galleryMain.querySelector('[data-gallery-img]');
    var videoWrap = galleryMain.querySelector('[data-gallery-video]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var thumbsContainer = root.querySelector('[data-gallery-thumbs]');

    // Set stagger delays for thumbnail drop-in animation
    thumbs.forEach(function(thumb, i) {
      var el = thumb.closest('.pp-gallery__thumb') || thumb;
      el.style.setProperty('--thumb-delay', (i * 0.06) + 's');
    });

    var currentGalleryIndex = 0;
    var foundActive = false;
    thumbs.forEach(function(thumb, i) {
      var el = thumb.closest('.pp-gallery__thumb') || thumb;
      if (el.classList.contains('active')) { currentGalleryIndex = i; foundActive = true; }
    });
    if (!foundActive && mainImg) {
      var initSrc = mainImg.getAttribute('src');
      thumbs.forEach(function(thumb, i) {
        if (thumb.getAttribute('data-media-src') === initSrc) {
          currentGalleryIndex = i;
          var el = thumb.closest('.pp-gallery__thumb') || thumb;
          el.classList.add('active');
        }
      });
    }

    function centerThumb(thumb, smooth) {
      if (!thumbsContainer || !thumb) return;
      var thumbEl = thumb.closest('.pp-gallery__thumb') || thumb;
      var thumbLeft = thumbEl.offsetLeft;
      var thumbWidth = thumbEl.offsetWidth;
      var containerWidth = thumbsContainer.clientWidth;
      var scrollTarget = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);
      if (smooth) {
        thumbsContainer.scrollTo({ left: scrollTarget, behavior: 'smooth' });
      } else {
        thumbsContainer.scrollLeft = scrollTarget;
      }
    }
    setTimeout(function() { centerThumb(thumbs[currentGalleryIndex], false); }, 50);

    // Slow push-in on the image being viewed. Restarted on every swap so each
    // picture gets its own move; CSS gates it on .pp-gallery.is-visible, so
    // nothing animates until the gallery has been scrolled to.
    function restartPushIn() {
      if (!mainImg) return;
      mainImg.classList.remove('is-pushing');
      void mainImg.offsetWidth;   // reflow, or re-adding in the same frame is a no-op
      mainImg.classList.add('is-pushing');
    }
    if (mainImg) {
      // 'load' is what lands on the right frame for a swapped-in image; the
      // complete check covers one that was already cached at page load.
      mainImg.addEventListener('load', restartPushIn);
      if (mainImg.complete) restartPushIn();
    }

    function selectGalleryThumb(index) {
      if (thumbs.length === 0) return;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentGalleryIndex = index;

      var thumb = thumbs[index];
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');

      var videoUrl = thumb.getAttribute('data-video-url');
      var mediaSrc = thumb.getAttribute('data-media-src');

      if (videoUrl && videoWrap) {
        var embedUrl = youtubeEmbed(videoUrl);
        if (embedUrl) {
          videoWrap.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
          videoWrap.style.display = '';
          if (mainImg) mainImg.style.display = 'none';
        }
      } else if (mediaSrc && mainImg) {
        if (videoWrap) { videoWrap.style.display = 'none'; videoWrap.innerHTML = ''; }
        mainImg.style.display = '';
        mainImg.src = mediaSrc;
        // Re-selecting the same image sets an identical src, which fires no
        // load event -- restart here so that case still moves.
        restartPushIn();
      }

      centerThumb(thumb, true);
    }

    thumbs.forEach(function(thumb, idx) {
      thumb.addEventListener('click', function() { selectGalleryThumb(idx); });
    });

    // Main image prev/next arrows
    var mainPrev = root.querySelector('[data-main-prev]');
    var mainNext = root.querySelector('[data-main-next]');
    if (mainPrev) mainPrev.addEventListener('click', function() { selectGalleryThumb(currentGalleryIndex - 1); });
    if (mainNext) mainNext.addEventListener('click', function() { selectGalleryThumb(currentGalleryIndex + 1); });

    // Keyboard left/right arrow navigation
    var galleryViewer = root.querySelector('[data-gallery-viewer]');
    if (galleryViewer) {
      galleryViewer.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); selectGalleryThumb(currentGalleryIndex - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); selectGalleryThumb(currentGalleryIndex + 1); }
      });
    }

    // Carousel arrows for thumbnail strip
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    if (thumbsContainer && prevBtn && nextBtn) {
      prevBtn.hidden = false;
      nextBtn.hidden = false;
      prevBtn.addEventListener('click', function() { selectGalleryThumb(currentGalleryIndex - 1); });
      nextBtn.addEventListener('click', function() { selectGalleryThumb(currentGalleryIndex + 1); });
    }

    // Image lightbox on main image click
    if (mainImg) {
      mainImg.addEventListener('click', function() {
        if (mainImg.style.display === 'none') return;
        openImageLightbox(currentGalleryIndex);
      });
    }
  }

  // --- Image Lightbox with prev/next + swipe ---
  var lightbox = document.getElementById('pp-lightbox');
  var lightboxContent = document.getElementById('pp-lightbox-content');
  var lightboxClose = document.getElementById('pp-lightbox-close');
  var lightboxPrev = document.getElementById('pp-lightbox-prev');
  var lightboxNext = document.getElementById('pp-lightbox-next');
  var lightboxMode = '';
  var lightboxIndex = 0;

  // Collect all image-only thumbs for lightbox navigation
  var imageThumbs = [];
  root.querySelectorAll('[data-gallery-thumb]').forEach(function(t, i) {
    if (t.getAttribute('data-media-src')) imageThumbs.push({ index: i, src: t.getAttribute('data-media-src') });
  });

  function preloadLightboxNeighbors(idx) {
    [-1, 1].forEach(function(offset) {
      var ni = idx + offset;
      if (ni < 0) ni = imageThumbs.length - 1;
      if (ni >= imageThumbs.length) ni = 0;
      var img = new Image();
      img.src = imageThumbs[ni].src;
    });
  }

  function openImageLightbox(galleryIdx) {
    var lbIdx = 0;
    for (var i = 0; i < imageThumbs.length; i++) {
      if (imageThumbs[i].index === galleryIdx) { lbIdx = i; break; }
    }
    lightboxMode = 'image';
    lightboxIndex = lbIdx;
    showLightboxImage(lbIdx);
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (lightboxPrev) lightboxPrev.style.display = '';
    if (lightboxNext) lightboxNext.style.display = '';
    lightboxContent.className = 'pp-lightbox__content';
    if (floatCart) floatCart.classList.add('visible');
  }

  function showLightboxImage(idx) {
    if (idx < 0) idx = imageThumbs.length - 1;
    if (idx >= imageThumbs.length) idx = 0;
    lightboxIndex = idx;
    lightboxContent.innerHTML = '<img src="' + imageThumbs[idx].src + '" alt="Gallery image">';
    preloadLightboxNeighbors(idx);
  }

  function closeLightbox() {
    lightbox.classList.remove('open');
    lightboxContent.innerHTML = '';
    lightboxContent.className = 'pp-lightbox__content';
    lightboxMode = '';
    document.body.style.overflow = '';
    if (floatCart) {
      var heroH = root.querySelector('.pp-hero');
      var threshold = heroH ? heroH.offsetHeight : 500;
      if (window.scrollY <= threshold) floatCart.classList.remove('visible');
    }
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

  // A swipe ends in a synthesized click on some browsers; this stops that
  // click from advancing a second time on top of the swipe.
  var lightboxSwipeNav = false;

  if (lightbox) lightbox.addEventListener('click', function(e) {
    if (lightboxMode === 'image') {
      // The arrows and the close button handle themselves.
      if (e.target.closest('.pp-lightbox__nav, .pp-lightbox__close')) return;
      if (lightboxSwipeNav) return;
      // Tapping the photo moves to the next one; tapping off it closes.
      if (e.target.tagName === 'IMG') { showLightboxImage(lightboxIndex + 1); return; }
      closeLightbox();
      return;
    }
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function(e) {
    if (!lightbox || !lightbox.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (lightboxMode === 'image') {
      if (e.key === 'ArrowLeft') showLightboxImage(lightboxIndex - 1);
      if (e.key === 'ArrowRight') showLightboxImage(lightboxIndex + 1);
    }
  });
  if (lightboxPrev) lightboxPrev.addEventListener('click', function(e) {
    e.stopPropagation();
    if (lightboxMode === 'image') showLightboxImage(lightboxIndex - 1);
  });
  if (lightboxNext) lightboxNext.addEventListener('click', function(e) {
    e.stopPropagation();
    if (lightboxMode === 'image') showLightboxImage(lightboxIndex + 1);
  });

  // Touch swipe support for lightbox
  (function() {
    var touchStartX = 0;
    var touchStartY = 0;
    if (!lightbox) return;
    lightbox.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    lightbox.addEventListener('touchmove', function(e) {
      if (lightboxMode === 'image') e.preventDefault();
    }, { passive: false });
    lightbox.addEventListener('touchend', function(e) {
      if (lightboxMode !== 'image') return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      var absDx = Math.abs(dx);
      var absDy = Math.abs(dy);
      if (absDx > absDy && absDx > 50) {
        if (dx < 0) showLightboxImage(lightboxIndex + 1);
        else showLightboxImage(lightboxIndex - 1);
      } else if (absDy > 50) {
        if (dy < 0) showLightboxImage(lightboxIndex + 1);
        else showLightboxImage(lightboxIndex - 1);
      }
    }, { passive: true });
  })();

  // --- Reviews Carousel with Auto-Rotate ---
  var reviewsSection = root.querySelector('[data-reviews-section]');
  var reviewsTrack = root.querySelector('[data-reviews-track]');
  if (reviewsTrack) {
    var reviewSlides = Array.from(reviewsTrack.querySelectorAll('.pp-review'));
    var reviewIndex = 0;
    var autoRotateInterval = null;
    var autoRotatePaused = false;

    function getVisibleCount() {
      if (window.innerWidth >= 1024) return 3;
      if (window.innerWidth >= 768) return 2;
      return 1;
    }

    function updateReviewsPosition() {
      var visible = getVisibleCount();
      var maxIndex = Math.max(0, reviewSlides.length - visible);
      if (reviewIndex > maxIndex) reviewIndex = maxIndex;
      if (reviewIndex < 0) reviewIndex = 0;
      var pct = -(reviewIndex * (100 / visible));
      reviewsTrack.style.transform = 'translateX(' + pct + '%)';
      var centerIdx = reviewIndex + Math.floor(visible / 2);
      reviewSlides.forEach(function(s, i) {
        s.classList.toggle('is-center', i === centerIdx);
      });
    }

    function nextSlide() {
      var visible = getVisibleCount();
      var maxIndex = Math.max(0, reviewSlides.length - visible);
      reviewIndex++;
      if (reviewIndex > maxIndex) reviewIndex = 0;
      updateReviewsPosition();
    }

    function prevSlide() {
      var visible = getVisibleCount();
      var maxIndex = Math.max(0, reviewSlides.length - visible);
      reviewIndex--;
      if (reviewIndex < 0) reviewIndex = maxIndex;
      updateReviewsPosition();
    }

    function startAutoRotate() {
      if (autoRotateInterval) return;
      autoRotateInterval = setInterval(function() {
        if (!autoRotatePaused) nextSlide();
      }, 5000);
    }

    function stopAutoRotate() {
      if (autoRotateInterval) {
        clearInterval(autoRotateInterval);
        autoRotateInterval = null;
      }
    }

    if (reviewsSection) {
      reviewsSection.addEventListener('mouseenter', function() { autoRotatePaused = true; });
      reviewsSection.addEventListener('mouseleave', function() { autoRotatePaused = false; });
    }

    // Click review to center it
    reviewSlides.forEach(function(slide, i) {
      slide.addEventListener('click', function() {
        var visible = getVisibleCount();
        var maxIndex = Math.max(0, reviewSlides.length - visible);
        var targetIndex = i - Math.floor(visible / 2);
        if (targetIndex < 0) {
          prevSlide();
        } else if (targetIndex > maxIndex) {
          nextSlide();
        } else {
          reviewIndex = targetIndex;
          updateReviewsPosition();
        }
        stopAutoRotate();
      });
    });

    var revPrevBtn = root.querySelector('[data-reviews-prev]');
    var revNextBtn = root.querySelector('[data-reviews-next]');
    if (revPrevBtn) revPrevBtn.addEventListener('click', function() { prevSlide(); });
    if (revNextBtn) revNextBtn.addEventListener('click', function() { nextSlide(); });

    window.addEventListener('resize', updateReviewsPosition);
    updateReviewsPosition();

    // Touch swipe for reviews
    var revTouchStartX = 0;
    reviewsTrack.addEventListener('touchstart', function(e) { revTouchStartX = e.touches[0].clientX; }, { passive: true });
    reviewsTrack.addEventListener('touchend', function(e) {
      var diff = revTouchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) nextSlide(); else prevSlide();
      }
    }, { passive: true });

    // Start auto-rotate when visible
    if ('IntersectionObserver' in window && reviewsSection) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) startAutoRotate();
          else stopAutoRotate();
        });
      }, { threshold: 0.2 });
      observer.observe(reviewsSection);
    } else {
      startAutoRotate();
    }
  }

  // --- Game Clips Slideshow ---
  var clipsContainer = root.querySelector('[data-clips]');
  if (clipsContainer) {
    var clipSlides = clipsContainer.querySelectorAll('[data-clip-slide]');
    var clipIndex = 0;
    var clipTimeout = parseInt(clipsContainer.getAttribute('data-timeout')) || 7;

    function showClip(idx) {
      clipSlides.forEach(function(s, i) {
        s.classList.toggle('active', i === idx);
        var vid = s.querySelector('video');
        if (vid) { if (i === idx) { vid.play().catch(function(){}); } else { vid.pause(); } }
      });
    }

    function nextClip() { clipIndex = (clipIndex + 1) % clipSlides.length; showClip(clipIndex); }

    var clipTimer = setInterval(nextClip, clipTimeout * 1000);

    var clipPrev = clipsContainer.querySelector('[data-clip-prev]');
    var clipNext = clipsContainer.querySelector('[data-clip-next]');
    if (clipPrev) clipPrev.addEventListener('click', function() {
      clearInterval(clipTimer);
      clipIndex = (clipIndex - 1 + clipSlides.length) % clipSlides.length;
      showClip(clipIndex);
    });
    if (clipNext) clipNext.addEventListener('click', function() {
      clearInterval(clipTimer);
      nextClip();
    });
  }

  // --- Sticky Nav Scroll Spy ---
  var navLinks = root.querySelectorAll('.pp-nav__item a[href^="#"]');
  var sections = [];
  navLinks.forEach(function(link) {
    var id = link.getAttribute('href').substring(1);
    var sec = document.getElementById(id);
    if (sec) sections.push({ el: sec, link: link });
  });

  function updateScrollSpy() {
    var scrollPos = window.scrollY + 100;
    var active = null;
    sections.forEach(function(s) {
      if (s.el.offsetTop <= scrollPos) active = s;
    });
    navLinks.forEach(function(l) { l.classList.remove('active'); });
    if (active) active.link.classList.add('active');
  }

  if (sections.length > 0) {
    window.addEventListener('scroll', updateScrollSpy, { passive: true });
    updateScrollSpy();
  }

  // --- Video Lightbox triggers ---
  root.querySelectorAll('[data-open-lightbox]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = btn.getAttribute('data-open-lightbox');
      var embedUrl = youtubeEmbed(url);
      if (embedUrl && lightboxContent) {
        lightboxMode = 'video';
        lightboxContent.className = 'pp-lightbox__content pp-lightbox__content--video';
        lightboxContent.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
        lightbox.classList.add('open');
        document.body.style.overflow = 'hidden';
        if (lightboxPrev) lightboxPrev.style.display = 'none';
        if (lightboxNext) lightboxNext.style.display = 'none';
        if (floatCart) floatCart.classList.add('visible');
      }
    });
  });

  // Edition add-to-cart buttons
  root.querySelectorAll('[data-edition-add]').forEach(function(btn) {
    btn.addEventListener('click', function() { addToCart(btn.getAttribute('data-variant-id'), btn); });
  });

  // Deluxe edition add-to-cart button
  root.querySelectorAll('[data-deluxe-add]').forEach(function(btn) {
    btn.addEventListener('click', function() { addToCart(btn.getAttribute('data-variant-id'), btn); });
  });

  // Related products quick add-to-cart (skip upsell drawer)
  root.querySelectorAll('[data-quick-add]').forEach(function(btn) {
    btn.addEventListener('click', function() { addToCart(btn.getAttribute('data-variant-id'), btn, true); });
  });

  // --- Parallax Effect on Background Images ---
  var parallaxBgs = root.querySelectorAll('.pp-hero__bg img, .pp-thematic__bg img, .pp-reviews__bg img');
  if (parallaxBgs.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    function updateParallax() {
      parallaxBgs.forEach(function(img) {
        var section = img.closest('.pp-hero, .pp-thematic, .pp-reviews');
        if (!section) return;
        var rect = section.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        if (rect.bottom > 0 && rect.top < windowHeight) {
          var scrollPercent = (windowHeight - rect.top) / (windowHeight + rect.height);
          var translateY = (scrollPercent - 0.5) * 160;
          var centeredness = 1 - Math.abs(scrollPercent - 0.5) * 2;
          var scale = 1 + centeredness * 0.04;
          img.style.transform = 'translateY(' + translateY + 'px) scale(' + scale.toFixed(4) + ')';
        }
      });
    }
    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
  }

  // --- Scroll Reveal Animations ---
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealEls = root.querySelectorAll('.pp-reveal, .pp-reveal-stagger, .pp-gallery');
    if (revealEls.length > 0 && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
            if (entry.target.classList.contains('pp-gallery')) {
              var nextArrow = entry.target.querySelector('[data-main-next]');
              if (nextArrow) {
                setTimeout(function() {
                  nextArrow.classList.add('wiggle');
                  nextArrow.addEventListener('animationend', function() {
                    nextArrow.classList.remove('wiggle');
                  }, { once: true });
                }, 2000);
              }
            }
          }
        });
      }, {
        // A ratio threshold scales with the element, so it fired absurdly late
        // on the tall ones: `.pp-deluxe` carries `pp-reveal` on the whole
        // section, and 30% of a multi-screen section meant scrolling well into
        // it before it appeared. Trigger on the top edge instead — any part
        // entering the viewport's upper 92% — which behaves the same for a
        // heading and for a section ten times its height.
        threshold: 0,
        rootMargin: '0px 0px -8% 0px'
      });
      revealEls.forEach(function(el) { revealObserver.observe(el); });
    }

    // Mobile: push-in / pull-out per gameplay item.
    //
    // The CSS keeps these items visible until `pp-gameplay--armed` is set, which
    // only happens once the observer below is actually watching them. Hiding
    // them from CSS and relying on this block to reveal them meant the section
    // went permanently blank whenever the block didn't run — and it reads the
    // breakpoint once, so narrowing a desktop window past 749px did exactly
    // that.
    var gameplayGrid = root.querySelector('.pp-gameplay__grid');
    var gameplayItems = root.querySelectorAll('.pp-gameplay__item');
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var mobileReveal = null;

    function armMobileReveal() {
      if (mobileReveal || !gameplayGrid || gameplayItems.length === 0) return;
      if (!('IntersectionObserver' in window)) return;
      mobileReveal = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      }, { threshold: 0.15 });
      gameplayItems.forEach(function(el) { mobileReveal.observe(el); });
      gameplayGrid.classList.add('pp-gameplay--armed');
    }

    function disarmMobileReveal() {
      if (!mobileReveal) return;
      mobileReveal.disconnect();
      mobileReveal = null;
      gameplayGrid.classList.remove('pp-gameplay--armed');
      gameplayItems.forEach(function(el) { el.classList.remove('is-visible'); });
    }

    if (mobileQuery.matches) armMobileReveal();
    // Crossing the breakpoint after load is how this gets tested, and on a phone
    // it happens on every rotation.
    var onBreakpointChange = function(e) {
      if (e.matches) { armMobileReveal(); } else { disarmMobileReveal(); }
    };
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpointChange);
    else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpointChange);
  }

  // --- Deluxe panel videos ---
  //
  // Same contract as the thematic background: no autoplay attribute, nothing
  // fetched until the panel is near the viewport, nothing shown until the clip
  // is really playing, and paused when scrolled away. These are opaque (no
  // alpha), so unlike the thematic clip they are fine in Safari.
  var panelVideos = root.querySelectorAll('[data-pp-panel-video]');
  if (panelVideos.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var panelObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.src) {
            v.src = v.getAttribute('data-src');
            v.addEventListener('playing', function() {
              v.classList.add('is-playing');
            }, { once: true });

          }
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function() { /* still remains visible */ });
        } else if (v.src) {
          v.pause();
        }
      });
    }, { rootMargin: '250px 0px' });
    panelVideos.forEach(function(v) { panelObserver.observe(v); });
  }

  // --- Mode cards: one plays at a time, by hover or by click ---
  //
  // Deliberately NOT the autoplay-when-visible behaviour the deluxe panels
  // use: four clips at once is noisy and costs four downloads. Exactly one
  // runs. A click PINS a card; hovering another previews it and releases back
  // to the pinned one on leave. Hover is gated on a real hover device, since
  // on touch a tap fires mouseenter and would fight the click.
  var modeCards = Array.prototype.slice.call(root.querySelectorAll('[data-pp-mode-card]'));
  if (modeCards.length) {
    var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var pinned = null;
    var hovered = null;
    var armed = false;

    function activeCard() { return hovered || pinned; }

    function apply(play) {
      var active = activeCard();
      modeCards.forEach(function(card) {
        var v = card.querySelector('[data-pp-mode-video]');
        var on = (card === active);
        card.classList.toggle('is-focused', on);
        card.classList.toggle('is-pinned', card === pinned);
        card.setAttribute('aria-pressed', card === pinned ? 'true' : 'false');
        if (!v) return;
        if (on && play) {
          if (!v.src) {
            v.src = v.getAttribute('data-src');
            v.addEventListener('playing', function() {
              v.classList.add('is-playing');
            }, { once: true });
          } else if (v.paused) {
            // Rewind a clip that was parked, otherwise re-selecting a card
            // that had already run did nothing visible.
            try { v.currentTime = 0; } catch (e) { /* not seekable yet */ }
            v.classList.add('is-playing');
          }
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function() { /* still remains visible */ });
        } else {
          // Settle back to the still rather than freezing on a stray frame.
          v.pause();
          v.classList.remove('is-playing');
          try { v.currentTime = 0; } catch (e) { /* not seekable yet */ }
        }
      });
    }

    modeCards.forEach(function(card) {
      card.addEventListener('click', function() {
        pinned = card;
        hovered = null;
        apply(motionOK && armed);
      });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          pinned = card;
          hovered = null;
          apply(motionOK && armed);
        }
      });
      card.addEventListener('focus', function() {
        if (!armed) return;
        hovered = card;
        apply(motionOK);
      });
      card.addEventListener('blur', function() {
        if (hovered === card) { hovered = null; apply(motionOK && armed); }
      });
      if (hoverCapable) {
        card.addEventListener('mouseenter', function() {
          if (!armed) return;
          hovered = card;
          apply(motionOK);
        });
        card.addEventListener('mouseleave', function() {
          if (hovered === card) { hovered = null; apply(motionOK); }
        });
      }
    });

    // Nothing is fetched until the section is near the viewport, so a visitor
    // who never scrolls this far downloads none of the clips.
    pinned = modeCards[0];
    if ('IntersectionObserver' in window) {
      var modeObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !armed) {
            armed = true;
            apply(motionOK);
            modeObs.disconnect();
          }
        });
      }, { rootMargin: '200px 0px' });
      modeObs.observe(modeCards[0]);
    } else {
      apply(false);
    }
  }

  // --- Thematic background video (alpha token fall) ---
  //
  // Deliberately opt-in rather than an `autoplay` attribute: a looping
  // full-bleed video costs bandwidth and battery, and the section reads fine
  // on the still alone. It loads only on a wide viewport, only when motion is
  // welcome, and only once the section is actually near the viewport — and it
  // pauses again when scrolled away.
  var bgVideoWrap = root.querySelector('[data-pp-bg-video]');
  if (bgVideoWrap) {
    var bgVideo = bgVideoWrap.querySelector('video');
    var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Narrow viewports get a 640x360 cut (~1.4MB vs ~3.4MB). Chosen once, on
    // the viewport as it is when the section is first reached, rather than
    // swapped on resize -- restarting the clip mid-scroll to save bytes the
    // visitor has already spent would be worse than letting it run.
    var narrow = window.matchMedia('(max-width: 899px)').matches;
    var srcAttr = narrow ? 'data-src-sm' : 'data-src';

    // Safari plays VP9 WebM but ignores its alpha channel, which would paint a
    // black rectangle over the artwork rather than falling back gracefully.
    // There is no feature query for alpha support, so this is a UA check by
    // necessity; getting it wrong only costs Safari the animation, never the
    // section. Chrome and Edge both carry "Safari" in their UA, hence the
    // exclusions.
    var ua = navigator.userAgent;
    var isSafari = /Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR/.test(ua);

    if (bgVideo && motionOK && !isSafari && 'IntersectionObserver' in window) {
      var started = false;
      var bgObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            if (!started) {
              started = true;
              bgVideo.src = bgVideo.getAttribute(srcAttr) || bgVideo.getAttribute('data-src');
              // Only reveal once frames are really coming, so a stalled
              // download never flashes an empty layer over the artwork.
              bgVideo.addEventListener('playing', function() {
                bgVideoWrap.classList.add('is-playing');
              }, { once: true });
            }
            var p = bgVideo.play();
            if (p && p.catch) p.catch(function() { /* autoplay refused; still shows */ });
          } else if (started) {
            bgVideo.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      bgObserver.observe(bgVideoWrap);
    }
  }

  // --- Hash Detection for Deep Links ---
  function handleHash() {
    var hash = window.location.hash;
    if (hash === '#htp') hash = '#how-to-play';
    if (hash === '#overview' || hash === '#how-to-play') {
      var target = document.querySelector(hash);
      if (target) {
        setTimeout(function() {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var lazyVideo = target.querySelector('.lazyvideo[data-video-url]');
          if (lazyVideo && !lazyVideo.querySelector('iframe')) {
            var vUrl = lazyVideo.getAttribute('data-video-url');
            var eUrl = youtubeEmbed(vUrl);
            if (eUrl) {
              lazyVideo.innerHTML = '<iframe src="' + eUrl + '" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
            }
          }
        }, 500);
      }
    }
  }
  handleHash();
  window.addEventListener('hashchange', handleHash);

  // --- Lazy Video Loading ---
  function loadLazyVideos() {
    root.querySelectorAll('.lazyvideo[data-video-url]').forEach(function(el) {
      if (el.querySelector('iframe')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 300) {
        var vUrl = el.getAttribute('data-video-url');
        var eUrl = youtubeEmbed(vUrl);
        if (eUrl) {
          el.innerHTML = '<iframe src="' + eUrl.replace('autoplay=1', 'autoplay=0') + '" allow="encrypted-media" allowfullscreen loading="lazy"></iframe>';
        }
      }
    });
  }
  window.addEventListener('scroll', loadLazyVideos, { passive: true });
  setTimeout(loadLazyVideos, 1000);

  // --- Deluxe Shimmer Sparkles ---
  var shimmerCanvas = root.querySelector('[data-shimmer-canvas]');
  if (shimmerCanvas) {
    var ctx = shimmerCanvas.getContext('2d');
    var particles = [];
    var particleCount = 60;
    var animId = null;
    var isVisible = false;

    function resizeCanvas() {
      var rect = shimmerCanvas.parentElement.getBoundingClientRect();
      shimmerCanvas.width = rect.width;
      shimmerCanvas.height = rect.height;
    }

    function createParticle() {
      var golden = Math.random() > 0.3;
      return {
        x: Math.random() * shimmerCanvas.width,
        y: Math.random() * shimmerCanvas.height,
        size: Math.random() * 2.5 + 0.5,
        speedX: (Math.random() - 0.5) * 0.3,
        speedY: -Math.random() * 0.4 - 0.1,
        opacity: 0,
        maxOpacity: Math.random() * 0.7 + 0.3,
        fadeSpeed: Math.random() * 0.008 + 0.003,
        phase: Math.random() * Math.PI * 2,
        twinkleSpeed: Math.random() * 0.03 + 0.01,
        r: golden ? 200 + Math.floor(Math.random() * 55) : 200,
        g: golden ? 164 + Math.floor(Math.random() * 40) : 200,
        b: golden ? 60 + Math.floor(Math.random() * 40) : 220,
        growing: true
      };
    }

    function initParticles() {
      particles = [];
      for (var i = 0; i < particleCount; i++) {
        var p = createParticle();
        p.opacity = Math.random() * p.maxOpacity;
        particles.push(p);
      }
    }

    function animateShimmer() {
      ctx.clearRect(0, 0, shimmerCanvas.width, shimmerCanvas.height);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.speedX;
        p.y += p.speedY;
        p.phase += p.twinkleSpeed;
        var twinkle = (Math.sin(p.phase) + 1) / 2;
        if (p.growing) {
          p.opacity += p.fadeSpeed;
          if (p.opacity >= p.maxOpacity) p.growing = false;
        } else {
          p.opacity -= p.fadeSpeed * 0.6;
          if (p.opacity <= 0) {
            particles[i] = createParticle();
            continue;
          }
        }
        var drawOpacity = p.opacity * (0.4 + twinkle * 0.6);
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size * (0.8 + twinkle * 0.4), 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + drawOpacity + ')';
        ctx.fill();
        if (p.size > 1.5 && twinkle > 0.7) {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size * 2, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + (drawOpacity * 0.15) + ')';
          ctx.fill();
        }
      }
      animId = requestAnimationFrame(animateShimmer);
    }

    var shimmerObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !isVisible) {
          isVisible = true;
          resizeCanvas();
          initParticles();
          animateShimmer();
        } else if (!entry.isIntersecting && isVisible) {
          isVisible = false;
          if (animId) cancelAnimationFrame(animId);
        }
      });
    }, { threshold: 0.05 });
    shimmerObserver.observe(shimmerCanvas.parentElement);

    window.addEventListener('resize', function() {
      if (isVisible) resizeCanvas();
    });
  }

  // The 3D box rotator moved to assets/boxart.js (snippet: boxart.liquid),
  // so any section can use it. It wires itself; nothing to call from here.

  // --- Side-by-side variant cards ---
  // The cards are a skin over the existing <select>: clicking one sets the
  // select's value and fires `change`, so price/availability/CTA syncing all
  // runs through the single code path above rather than a parallel copy.
  var variantCards = root.querySelectorAll('[data-pp-variant-card]');
  if (variantCards.length && variantSelect) {
    var variantRow = root.querySelector('.pp-hero__variant-row');
    if (variantRow) variantRow.classList.add('pp-hero__variant-row--hidden');

    // Swap the hero art to the chosen edition's box, when per-edition art exists.
    var editionArt = root.querySelectorAll('[data-pp-edition-art]');
    var showEditionArt = function(name) {
      if (!editionArt.length || !name) return;
      editionArt.forEach(function(block) {
        block.classList.toggle('is-active', block.getAttribute('data-pp-edition-art') === name);
      });
    };

    var syncCards = function(id) {
      variantCards.forEach(function(card) {
        var on = card.getAttribute('data-variant-id') === String(id);
        card.classList.toggle('is-selected', on);
        if (on) {
          var nameEl = card.querySelector('.pp-variant-card__name');
          if (nameEl) showEditionArt(nameEl.textContent.trim());
        }
      });
    };

    variantCards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        // Each card carries its own action button; let those handle themselves.
        if (e.target.closest('button')) return;
        variantSelect.value = card.getAttribute('data-variant-id');
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncCards(card.getAttribute('data-variant-id'));
      });
    });

    // Per-card add to cart — acts on that card's variant, not the selection.
    root.querySelectorAll('[data-pp-card-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        addToCart(btn.getAttribute('data-variant-id'), btn);
      });
    });

    // Keep the cards right if anything else changes the variant.
    variantSelect.addEventListener('change', function() { syncCards(variantSelect.value); });
    syncCards(variantSelect.value);
  }

  // --- Notify modal (pre-release email capture) ---
  // Replaces the dead "Sold Out" buttons. Opens a form; never touches the cart.
  var notifyModal = document.getElementById('PpNotifyModal');
  if (notifyModal) {
    var notifyEdition = notifyModal.querySelector('[data-pp-notify-edition]');
    var notifyTitle = notifyModal.querySelector('.pp-notify__title');
    var lastFocused = null;

    var openNotify = function(label) {
      lastFocused = document.activeElement;
      if (notifyEdition) {
        if (label) {
          notifyEdition.textContent = label;
          notifyEdition.hidden = false;
        } else {
          notifyEdition.hidden = true;
        }
      }
      notifyModal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (notifyTitle) notifyTitle.focus({ preventScroll: true });
    };

    var closeNotify = function() {
      notifyModal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
    };

    // Delegated so buttons rendered anywhere on the page are covered.
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-pp-notify]');
      if (trigger) {
        e.preventDefault();
        openNotify(trigger.getAttribute('data-pp-notify'));
        return;
      }
      if (e.target.closest('[data-pp-notify-close]')) {
        e.preventDefault();
        closeNotify();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !notifyModal.hidden) closeNotify();
    });
  }

})();
